import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export type PublicShopSeoOverride = {
  type: 'shop';
  /** Filial nomi yoki slug fallback */
  branchLabel: string;
};

type OverrideState = PublicShopSeoOverride | null;

type PublicSeoContextValue = {
  shopOverride: OverrideState;
  setShopSeoOverride: (next: PublicShopSeoOverride | null) => void;
};

const PublicSeoContext = createContext<PublicSeoContextValue | null>(null);

export function PublicSeoProvider({ children }: { children: React.ReactNode }) {
  const [shopOverride, setShopSeoOverride] = useState<OverrideState>(null);

  const setShopSeoOverrideStable = useCallback((next: PublicShopSeoOverride | null) => {
    setShopSeoOverride(next);
  }, []);

  const value = useMemo(
    () => ({
      shopOverride,
      setShopSeoOverride: setShopSeoOverrideStable,
    }),
    [shopOverride, setShopSeoOverrideStable],
  );

  return <PublicSeoContext.Provider value={value}>{children}</PublicSeoContext.Provider>;
}

export function usePublicSeoShopOverride(): PublicSeoContextValue {
  const ctx = useContext(PublicSeoContext);
  if (!ctx) {
    throw new Error('usePublicSeoShopOverride must be used within PublicSeoProvider');
  }
  return ctx;
}
